import { AppIcons, AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, Chip, SxProps, Theme } from '@mui/material';

export type TypeChipProps = Readonly<{
  label: string;
  icon: AppIcons;
}>;

export const TypeChip = ({ label, icon }: TypeChipProps) => {
  return (
    <Box sx={typeChipContainerSx}>
      <Chip
        label={label}
        variant="pill"
        size="lg"
        icon={<AppIcon iconName={icon} diameter="16px" color="Brand/500" />}
        sx={typeChipSx}
      />
    </Box>
  );
};

const typeChipContainerSx: SxProps<Theme> = {
  width: 'fit-content',
};

const typeChipSx: SxProps<Theme> = ({ backrs }) => ({
  border: `1px solid ${backrs.colors['Brand/200']}`,
  backgroundColor: backrs.colors['Brand/50'],
  color: backrs.colors['Brand/700'],
  objectFit: 'contain',
  gap: backrs.spacing['spacing-sm'],
  height: ICON_SIZES['32px'],
});
